import { SuperEllipse, Typography } from '@themenu/design-system'
import { utcSP } from 'lib/utils/date'
import Link from 'next/link'
import { NotificationItem as TNotificationItem } from 'providers/notifications/types'

const chipPropsMap = {
  WARNING: {
    icon: 'warning-alt',
    colorSet: 'warning'
  },
  ERROR: {
    icon: 'error',
    colorSet: 'critical'
  },
  INFORMATION: {
    icon: 'information',
    colorSet: 'pot'
  },
  SUCCESS: {
    icon: 'check',
    colorSet: 'success'
  }
} as const

interface Props {
  item: TNotificationItem
  onLinkClick?: () => void
}

const NotificationItem: React.FC<Props> = ({ item, onLinkClick }) => {
  const { type, message, linkPath, notificationTime, linkLabel } = item

  return (
    <div className="grid md:grid-cols-[2fr,1fr] gap-8">
      <div className="grid gap-8 grid-cols-[24px,auto]">
        <SuperEllipse
          size={24}
          icon={chipPropsMap[type].icon || 'information'}
          colorSet={chipPropsMap[type].colorSet || 'pot'}
        />
        <div className="grid gap-4">
          <Typography variant="callout" weight="medium" className="self-center">
            {message}
          </Typography>
          {linkPath && (
            <Link href={linkPath} onClick={onLinkClick}>
              <Typography
                variant="callout"
                weight="medium"
                className="text-content-primary underline"
              >
                {linkLabel || 'Ver detalhes'}
              </Typography>
            </Link>
          )}
        </div>
      </div>
      <Typography
        variant="callout"
        className="text-content-subdued"
        align="right"
      >
        {utcSP(notificationTime).formatDate()}{' '}
        {utcSP(notificationTime).formatHour()}
      </Typography>
    </div>
  )
}

export default NotificationItem
